const dataToJson = (data) => {
  return JSON.stringify(data, null, 2);
};

export default dataToJson;
